import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { Stack, Flex, Cluster, Box } from '../../shared/layouts';
import Button from '../../shared/Button';
import Header from '../../shared/Header';
import { useNavigate } from 'react-router-dom';
import Card from '../../shared/Card';
import { settingsDateFormatter } from '../../../utils/dateHelpers';
import Table from '../../shared/Table';
import Modal from '../../shared/Modal';
import NextSvg from 'imagesUwKluis/svg/open.svg';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const columns = [
  {
    accessor: 'name',
    width: 400 * 0.33,
  },
  {
    accessor: 'status',
    width: 400 * 0.5,
  },
  {
    accessor: 'actions',
    width: 400 * 0.1,
    align: 'right',
  },
];

const DeniedRequests = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [connectModal, setConnectModal] = useState(null);
  const navigate = useNavigate();
  const { SettingsIcon } = useIconLibrary();

  useEffect(() => {
    axios
      .get('/user/settings/data', {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((res) => setData(res.data.revoked_clients))
      .catch((err) => console.err(err));
  }, []);

  const tableData = useMemo(
    () => data?.map((item) => ({
      name: item.name,
      content: item,
      status: t('Geweigerd op {{date}}', {date: settingsDateFormatter(new Date(item.date))}),
      actions: (
        <NextSvg
          width="1.5rem"
          height="1.5rem"
          css={(theme) => ({
            margin: 'calc((1rem - 1.5rem) / 2) 0',
            fill: theme?.colors?.secondaryFont || 'gray',
          })}
        />
      ),
    })) ?? [],
    [data]
  );
  return (
    <>
      <Modal
        isOpen={!!connectModal}
        onRequestClose={() => setConnectModal(false)}
      >
        <Stack space="l">
          <Box fontScale="xl" fontWeight="bold" textAlign="center" pt="5xl">
            {t('Opnieuw verbinden')}
          </Box>
          <Box textAlign="center">
            {t('Opnieuw verbinden met') + ' '}
            <Box color="primary" fontWeight="bold" display="inline-block">
              {connectModal?.name}?
            </Box>
            <Box>{t('Wat kunnen zij zien?')}</Box>
          </Box>
          <Flex justifyContent="center">
            <Box textAlign="left">
              {connectModal &&
                Object.values(connectModal.scopes).map((scope, i) => (
                  <li key={i}>{scope.name}</li>
                ))}
            </Box>
          </Flex>
        </Stack>
        <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
          <Button
            variant="primary-outline"
            onClick={() => {
              setConnectModal(null);
            }}
          >
            {t('Weigeren')}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              axios
                .post(`/toegang/bevestigen`, {
                  organization_name: connectModal.name,
                  reallow: 'true',
                  scopes: connectModal.scopes,
                })
                .then(() => {
                  navigate('/user/settings');
                })
                .catch((err) => console.error(err));
            }}
          >
            {t('Koppelen')}
          </Button>
        </Cluster>
      </Modal>
      <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
        <Header
          title={t("Instellingen")}
          icon={<SettingsIcon width="2rem" height="2rem" />}
          variant="page"
        />

        <Card>
          <Stack space="m" width="100%">
            <Header title={t("Verbroken verzoeken")} variant="section" />
            <Table
              columns={columns}
              data={tableData}
              handleRowClick={(item) => {
                setConnectModal(item.original.content);
              }}
            />
          </Stack>
          <Flex justifyContent="flex-end" mt="l">
            <Button
              variant="primary-outline"
              onClick={() => {
                navigate('/user/settings');
              }}
            >
              {t('Annuleren')}
            </Button>
          </Flex>
        </Card>
      </Stack>
    </>
  );
};

export default DeniedRequests;
